import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import ICollectionParams from '../../../models/params/ICollectionParams';
import { ICollectionResponse } from '../../../models/responces/ICollectionResponse';
import IDataObjectParams from '../../../models/params/IDataObjectParams';

export interface ICRUDReadCollectionParams {
  dataObjectName: string;
  collectionParams: ICollectionParams;
  dataObjectParams?: IDataObjectParams;
}

const apiReadCollection = (params: ICRUDReadCollectionParams) =>
  sendAxiosRequest({
    method: 'get',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'crud',
      dataObjectName: params.dataObjectName,
      collectionParams: params.collectionParams || undefined,
      dataObjectParams: params.dataObjectParams
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<ICollectionResponse>;
export default apiReadCollection;
